// @flow

/**
 * Module dependencies.
 */

import { colors, units } from 'client/styles';
import Layout from 'client/components/core/layout';
import RawHtml from 'react-raw-html';
import React from 'react';
import Text from 'client/components/core/type';
import styled from 'styled-components';

/**
 * `Props` type.
 */

type Props = {
  message: string,
  visible: boolean
};

/**
 * `Message` component.
 */

const Message = styled(Layout)`
  transition: opacity .1s linear;

  ${({ active }) => `
    display: ${active ? 'block' : 'none'};
    opacity: ${active ? 1 : 0};
  `}
`;

/**
 * `ErrorMessageComponent` component.
 */

function ErrorMessageComponent(props: Props): React$Element<*> {
  const { message, visible } = props;

  return (
    <Message
      active={visible}
      paddingHorizontal={units(2)}
    >
      <Text.Paragraph color={colors.red}>
        <RawHtml.div>
          {message}
        </RawHtml.div>
      </Text.Paragraph>
    </Message>
  );
}

/**
 * Export `ErrorMessage`.
 */

export const ErrorMessage = ErrorMessageComponent;



// WEBPACK FOOTER //
// ../src/client/components/forms/components/messages/error.js